import "core-js/modules/es.array.reverse.js";
var _class, _class2;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { observer } from "mobx-react";
import { action, makeObservable } from "mobx";
import { Component } from "react";
import isDefined from "../../Core/isDefined";
import CommonStrata from "../../Models/Definition/CommonStrata";
import Styles from "./parameter-editors.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let EnumerationParameterEditor = observer(_class = (_class2 = class EnumerationParameterEditor extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }
  onChange(e) {
    this.props.parameter.setValue(CommonStrata.user, e.target.value);
  }
  render() {
    const value = this.props.parameter.value;
    return /*#__PURE__*/_jsxs("select", {
      className: Styles.field,
      onChange: this.onChange.bind(this),
      value: value,
      children: [(!isDefined(value) || !this.props.parameter.isRequired) && /*#__PURE__*/_jsx("option", {
        value: "",
        children: "Not specified"
      }, "__undefined__"), isDefined(value) && !this.props.parameter.options.find(option => option.id === value) && /*#__PURE__*/_jsxs("option", {
        value: value,
        children: ["Invalid value (", value, ")"]
      }, "__invalid__"), this.props.parameter.options.map((v, i) => {
        var _v$name;
        return /*#__PURE__*/_jsx("option", {
          value: v.id,
          children: (_v$name = v.name) !== null && _v$name !== void 0 ? _v$name : v.id
        }, i);
      })]
    });
  }
}, _applyDecoratedDescriptor(_class2.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onChange"), _class2.prototype), _class2)) || _class;
export { EnumerationParameterEditor as default };